<template>
  <div class="retrun-cn">
    <div style="text-align: right">
      <Print :print-value="printValue" @handleOn="handleOn" />
    </div>
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="详细信息" name="first">
          <el-scrollbar>
            <table style="width: 99%">
              <tr>
                <td colspan="6">
                  <h2 style="text-align: center">退 仓 单</h2>
                </td>
              </tr>
              <tr>
                <td colspan="2">经销商: {{ form.stockInfo.fDistributor }}</td>

              </tr>
              <tr>
                <td colspan="2">客户名称: {{ form.stockInfo.fCustomer }}</td>
                <td colspan="2">日期:{{ form.stockInfo.fDate }}</td>
                <td colspan="2">NO:{{ form.stockInfo.fBillNo }}</td>
              </tr>
              <tr>
                <td colspan="6">
                  <table class="tableDetails">
                    <tr>
                      <th>产品编号</th>
                      <th>产品名称</th>
                      <th>规格</th>
                      <th>单位</th>
                      <th>数量</th>
                      <th>生产日期</th>
                      <th>批号</th>
                      <th>消毒日期</th>

                      <th>备注</th>
                    </tr>
                    <tr
                      v-for="(item, index) in form.stockInfo.entrys"
                      :key="index"
                    >
                      <td>{{ item.fNumber }}</td>
                      <td>{{ item.fName }}</td>
                      <td>{{ item.fModel }}</td>
                      <td>{{ item.fUnit }}</td>
                      <td>{{ item.fQty }}</td>
                      <td>{{ item.fDate_Sc }}</td>

                      <td>{{ item.fBatchNo }}</td>
                      <td>{{ item.fDate_Xd }}</td>
                      <td>{{ item.fDes }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td>记账:{{ form.stockInfo.jz }}</td>
                <td>会计:{{ form.stockInfo.kj }}</td>
                <td>出纳:{{ form.stockInfo.cn }}</td>
                <td>部门主管:{{ form.stockInfo.bmzg }}</td>
                <td>保管:{{ form.stockInfo.bg }}</td>
                <!-- <td>提货人:{{ form.stockInfo.thr }}</td> -->
                <td>制单人:{{ form.stockInfo.createName }}</td>
              </tr>
            </table>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'
import Print from '../commonPrint/printButton'

export default {
  components: {
    ReturnNode, Print
  },
  data: function() {
    return {
      form: {
        stockInfo: {},
        procedureInfo: {},
        procedureMessage: []
      },
      printValue: null,
      rules: {},

      activeName: 'first',

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {},
  methods: {
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        throw '不可能到这里'
      }

      this.loading = true
      const res = await this.$httpPost(
        'SaleRetrun/SaleRetrunBillForCk/GetSaleRetrunBillForCk',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    currencyFormat: function(row, column, cellValue) {
      const val = cellValue
      if (val == undefined) {
        return ''
      }
      return Number(val).toFixed(2)
    },
    handleOn: function() {
      // console.log(this.form, 'this.form')
      this.printValue = this.form.fid
    }
  }
}
</script>
<style lang="less">
.retrun-cn {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
<style lang="less" scoped>
.retrun-cn {
  .wlinfo {
    .el-input,
    .el-select,
    .el-autocomplete,
    .el-textarea {
      width: 20% !important;
    }
  }

  .tableDetails {
    width: 100%;
    border-collapse: collapse;
  }

  .tableDetails,
  .tableDetails td,
  .tableDetails th {
    border: 1px solid black;
    text-align: center;
  }

  .tableDetails td,
  .tableDetails th {
    padding: 5px;
  }
}
</style>
